<template>
	<hero-banner :backgrounds="heroBackgrounds" class="customisable-banner homepage__banner">
		<div class="grid">
			<template :if="options">
				<div class="grid__item one-half--not-phab">
					<mq-layout mq="ltab+">
						<h1 class="homepage__banner-title">{{ heroTitle }}</h1>
						<div class="homepage__banner-description customisable-banner__description" v-html="heroDescription"></div>
					</mq-layout>
					<div v-if="page != 'PromotionalTools'" class="homepage__banner-ctas">
						<div class="grid grid--b32--not-phab grid--b8--phab grid--auto grid--middle grid--center--phab">

							<div v-if="!hasPermission && page != 'PromotionalTools'" class="grid__item">
								<br/>
								<theme-btn @click.native="$root.$data.showLoginForm = true">Login Now</theme-btn>
							</div>

							<template v-else>

								<div v-for="(cta, index) in options.cta" :key="index"	class="grid__item">
									<div v-if="cta.type == 'video_hero' && cta.videoId">
										<watch-video-hero-button
											v-bind:text="cta.text"
											v-bind:videoId="cta.videoId"
											v-bind:primaryCta="options.cta.indexOf(cta) == 0"
										></watch-video-hero-button>
									</div>

									<div v-if="cta.type == 'asset_hero'">
										<download-file-hero-button
											v-bind:text="cta.text"
											v-bind:asset="cta.asset"
											v-bind:primaryCta="options.cta.indexOf(cta) == 0"
											v-on:showGameInfo="showGameDetail($event)"
										></download-file-hero-button>
									</div>

									<div v-if="cta.type == 'game_hero'">
										<play-game-hero-button
											v-bind:text="cta.text"
											v-bind:gameId="cta.game"
											v-bind:primaryCta="options.cta.indexOf(cta) == 0"
										></play-game-hero-button>
									</div>

									<div v-if="cta.type == 'url_hero'">
										<link-hero-button
											v-bind:text="cta.text"
											v-bind:link="cta.url"
											v-bind:primaryCta="options.cta.indexOf(cta) == 0"
										></link-hero-button>
									</div>

									<div v-if="cta.type == 'news_hero'">
										<news-hero-button
											v-bind:text="cta.text"
											v-bind:newsId="cta.news"
											v-bind:primaryCta="options.cta.indexOf(cta) == 0"
										></news-hero-button>
									</div>

									<div v-if="cta.type == 'tournaments_hero'">
											<tournaments-hero-button
													v-bind:text="cta.text"
													v-bind:primaryCta="options.cta.indexOf(cta) == 0"
											></tournaments-hero-button>
									</div>

									<div v-if="!hasPermission" class="grid__item">
										<br/>
										<theme-btn @click.native="$root.$data.showLoginForm = true">Login Now</theme-btn>
									</div>

								</div>

							</template>
						</div>
					</div>
					<div v-if="page == 'PromotionalTools'" class="grid grid--b32--not-phab grid--b8--phab grid--auto grid--middle grid--center--phab">
						<div class="grid__item">
							<div class="promotional-tools__reg-btn-wrap">
								<br/>
								<a href="mailto:peter.nikashin@igt.com?subject=Engagement Platform interest">
									<btn
										class="promotional-tools__reg-btn btn--style--fill--white fc-pal--blue btn--shape--h48"
									>Request a Demo</btn>
								</a>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-if="hasRhsSlot">
	 			<div class="grid__item one-half--not-phab">
	 				<slot name="rightColumn"></slot>
				</div>
			</template>
		</div>
	</hero-banner>
</template>

<script>
import Btn from "../atoms/Btn";
import ThemeBtn from "../atoms/ThemeBtn";
import DownloadFileHeroButton from "./DownloadFileHeroButton";
import HeroBanner from "./HeroBanner";
import PlayGameHeroButton from "./PlayGameHeroButton";
import WatchVideoHeroButton from "./WatchVideoHeroButton";
import LinkHeroButton from "./LinkHeroButton";
import NewsHeroButton from "./NewsHeroButton";
import TournamentsHeroButton from "./TournamentsHeroButton";

export default {
	components: {
		Btn,
		ThemeBtn,
		DownloadFileHeroButton,
		HeroBanner,
		PlayGameHeroButton,
		WatchVideoHeroButton,
		LinkHeroButton,
		NewsHeroButton,
		TournamentsHeroButton,
	},
	data() {
		return {
			game: null
		};
	},
	props: {
		options: [Object, String],
		page: [String]
	},
	computed: {
		hasPermission: function()
		{
			return this.$root.userHasPermission({
				'igt': ['AM', 'CM', 'SA'],
				'operator': ['affiliate', 'customer', 'performance'],
			});
		},
		hasRhsSlot: function() {
			return this.$slots.rightColumn;
		},
		heroBackgrounds: function() {
			var self = this;
			var bgs = {};

			if (!self.options || !self.options.mobileBackgroundImage || !self.options.desktopBackgroundImage) return;

			bgs["mob"] = typeof self.options.mobileBackgroundImage == 'string' ? self.options.mobileBackgroundImage : self.options.mobileBackgroundImage.link;
			bgs["ptab"] = bgs["mob"];

			bgs["ltab"] = typeof self.options.desktopBackgroundImage == 'string' ? self.options.desktopBackgroundImage : self.options.desktopBackgroundImage.link;
			bgs["desk"] = bgs["ltab"];

			return bgs;
		},
		heroTitle: function() {
			var self = this;

			if (!self.options) return;

			if (self.options.title && self.options.title.length > 0) {
				return self.options.title;
			}
		},
		heroDescription: function() {
			var self = this;

			if (!self.options) return;

			if (self.options.description && self.options.description.length > 0) {
				return self.options.description;
			}
		}
	},
	methods: {
		showGameDetail(game) {
			var self = this;

			self.$emit('showGameInfo', game)
		}
	}
};
</script>
<style lang="scss">

	@import "src/scss/toolkit";

	$c: ".customisable-banner";
	#{$c}
	{
		&__description
		{
			@include media(not-phab)
			{
				max-width: 500px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/organisms/CustomisableBanner.vue